import {SubmitButton} from "components/Button";
import {FormCard} from "components/Form";
import {DashboardLayout} from "components/Layout";
import {CircleLoader} from "components/Loader";
import {useDetailHargaPendaftaranObat} from "hooks/SuperAdmin/HargaPendaftaranObat";
import {useHistory, useParams} from "react-router-dom";
import {convertToCurency} from "utils/converter";

const HargaPendaftaranObatDetail = () => {
	const history = useHistory();
	const {id} = useParams();
	const {data, isLoading} = useDetailHargaPendaftaranObat(id);

	if (isLoading) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar Harga Pendaftaran Obat" title="Detail Harga Pendaftaran Obat">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar Harga Pendaftaran Obat"
				title={`Detail Data Harga Pendaftaran Obat ${data?.data?.Hospital?.name}`}
				onBackButtonClick={() => history.push("/harga-pendaftaran-obat")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Rumah Sakit</label>
							<p className="text-bold text-grey">{data?.data?.Hospital?.name}</p>
						</div>
					</div>
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Harga</label>
							<p className="text-bold text-grey">Rp {convertToCurency(data?.data?.price + "")}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/harga-pendaftaran-obat/edit/${data?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
};

export {HargaPendaftaranObatDetail};
